import $ from 'jquery';

// in case we got "radio" buttons, this piece of js allows
// unchecking of an activated radio button. Every other
// behaviour is done in CSS.
$('.accordion--radio .accordion__header').on('click', function (ev) {
    const $parent = $(this).closest('.accordion__element');
    const $check = $parent.find('.accordion__check');
    if ($check.prop('checked')) {
        $check.prop('checked', false);
        ev.preventDefault();
    }
});

$('.accordion__content-wrap *').on('focus', function (ev) {
    $(this).closest('.accordion__element').find('.accordion__check').prop('checked', true);
    $(this).closest('.accordion__element').siblings().find('.accordion__check').prop('checked', false);
});

$('.accordion__toggle').on('click', function () {
    $(this).closest('.accordion__element').find('.accordion__check').trigger('click');
    $(this).closest('.accordion__element').siblings().find('.accordion__check').prop('checked', false);
})
